// TODO: make a parent class for this and ConfigCaseField (and other input fields)
import * as React from 'react';
import { TooltipHost, TextField, getTheme } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';
import { validateRulesFieldValue } from 'components/util/validation';
import { ValidationMessage } from './rules/ValidationMessage';
import { TooltipText } from '../shared';
import { settingsFieldStyles } from './SettingsStyles';
import { useEffect } from 'react';

interface ConfigFieldProps {
  id: string;
  label: string;
  tooltip: string;
}

export const MaxTraitField: React.FC<ConfigFieldProps> = props => {
  const { palette, fonts } = getTheme();

  const { state, dispatch } = React.useContext(AdminContext);
  const [value, setValue] = React.useState<string>('');
  const [showError, setError] = React.useState<boolean>(false);

  useEffect(() => {
    if (state.queueDataState) {
      setValue(String(state.queueDataState.uxPreferences.decide.maxAllowedLabels));
    }
  }, [state.queueDataState]);

  const onComponentChange = (event): void => {
    let tmpValue: string = event.target.value;
    if (tmpValue !== '0' && tmpValue !== '00' && tmpValue !== '') {
      tmpValue = validateRulesFieldValue(tmpValue, 1, 10).toString();
      setError(false);
    } else {
      tmpValue = '0';
      setError(true);
    }
    setValue(tmpValue);
    dispatch({
      type: 'MAX_ALLOWED_LABELS',
      payload: Number(tmpValue)
    });
    dispatch({
      type: 'IS_UPDATED',
      payload: true
    });
  };

  return (
    <TooltipHost content={props.tooltip}>
      <TextField
        id={props.id}
        label="Traits"
        value={value}
        onChange={(e): void => onComponentChange(e)}
        styles={settingsFieldStyles(palette, fonts, 60)}
        maxLength={2}
      />
      {showError && <ValidationMessage message={TooltipText.validationCaseMessage} fonts={fonts} />}
    </TooltipHost>
  );
};
